import { render, staticRenderFns } from "./billing-and-bank-details-container.vue?vue&type=template&id=0916bfb4&scoped=true&lang=pug"
import script from "./billing-and-bank-details-container.vue?vue&type=script&lang=ts"
export * from "./billing-and-bank-details-container.vue?vue&type=script&lang=ts"
import style0 from "./billing-and-bank-details-container.vue?vue&type=style&index=0&id=0916bfb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916bfb4",
  null
  
)

export default component.exports